export const EDITOR_VERSIONS_OPTIONS = [
  "id",
  "quarter",
  "year",
  "dateBegin",
  "IndicatorId",
  "IndicatorGroupId",
];
